import React from 'react';
import RelFormItems from './RelFormItems';

const RelationshipsForm = ({
  clientId,
  clientName,
  openDeleteModal,
  toggleAddClientForm,
  setNewEvent,
  setPrefixToSend,
  relationships,
  setNewRelationship,
}) => {
  return (
    <RelFormItems
      toggleAddClientForm={toggleAddClientForm}
      setNewEvent={setNewEvent}
      setPrefixToSend={setPrefixToSend}
      setNewRelationship={setNewRelationship}
      openDeleteModal={openDeleteModal}
      relationships={relationships}
      clientId={clientId}
      clientName={clientName}
    />
  );
};
export default RelationshipsForm;
